import { render, staticRenderFns } from "./weapon.vue?vue&type=template&id=fe059fb6&scoped=true&"
import script from "./weapon.vue?vue&type=script&lang=js&"
export * from "./weapon.vue?vue&type=script&lang=js&"
import style0 from "./weapon.vue?vue&type=style&index=0&id=fe059fb6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe059fb6",
  null
  
)

export default component.exports